import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

/**
 * `isMobile` from react-device-detect is resolved from the user agent at module
 * load time. The build is prerendered with a desktop headless browser, so using
 * it directly during render makes the first client render disagree with the
 * prerendered HTML and React throws the markup away (hydration mismatch).
 *
 * This hook always reports `false` on the first render (matching the prerendered
 * markup) and switches to the real value right after mount.
 */
const useIsMobile = () => {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    if (isMobile) setMobile(true);
  }, []);

  return mobile;
};

export default useIsMobile;
